import { createStructuredSelector, createSelector } from "reselect";
import {
  allowedOrganizationsSelector,
  userEmailSelector
} from "../../auth/selectors";

export const organizationSelector = state => state.organization;

export const filesSelector = state =>
  state.datatools.getIn(["upload", "files"]).toJS();

export const stepIndexSelector = state =>
  state.datatools.getIn(["upload", "stepIndex"]);

export const emailSelector = userEmailSelector;

export const selectedOrganizationSelector = state =>
  state.datatools.getIn(["upload", "selectedOrganization"]);

export const someFilesAreUploadingSelector = createSelector(
  filesSelector,
  files => files.some(file => file.isUploading)
);

// are any files validating
export const isValidatingSelector = createSelector(filesSelector, files =>
  files.some(file => file.isValidating)
);
export const filesNotYetUploadedSelector = createSelector(
  filesSelector,
  files => files.filter(file => !file.hasUploaded)
);
export const allFilesHaveValidatedSelector = createSelector(
  filesSelector,
  files => files.every(file => file.hasValidated)
);
// have all files passed the test-insert phase
export const allFilesTestInserted = createSelector(filesSelector, files =>
  files.every(file => file.hasTestInserted)
);

export const noFilesHaveValidationErrorsSelector = createSelector(
  filesSelector,
  files => files.every(file => !file.joiErrors.length && !file.errors.length)
);
export const allFilesUploadedSelector = createSelector(filesSelector, files =>
  files.every(file => file.hasUploaded)
);

export default createStructuredSelector({
  files: filesSelector,
  organization: organizationSelector,
  selectedOrganization: selectedOrganizationSelector,
  isValidating: isValidatingSelector,
  stepIndex: stepIndexSelector,
  noFilesHaveValidationErrors: noFilesHaveValidationErrorsSelector,
  allFilesUploaded: allFilesUploadedSelector,
  someFilesAreUploading: someFilesAreUploadingSelector,
  filesNotYetUploaded: filesNotYetUploadedSelector,
  email: emailSelector,
  allowedOrganizations: allowedOrganizationsSelector,
  allFilesHaveValidated: allFilesHaveValidatedSelector
});
